import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    base: 'space-y-5',
} satisfies TVConfig<typeof ui>['form'];
